import { Link } from 'react-router-dom'

import { DropGrid } from '@/components/drops/DropGrid'
import { SectionHeader } from '@/components/ui/SectionHeader'
import { useListings } from '@/hooks/useListings'

const PREVIEW_COUNT = 6

export function LatestDrops() {
  const { listings, loading, error, usingSamples } = useListings()
  const preview = listings.slice(0, PREVIEW_COUNT)

  return (
    <section aria-labelledby="latest-links-heading" className="space-y-8">
      <SectionHeader
        id="latest-links-heading"
        title="Latest links"
        action={{ label: 'Browse all', href: '/discover' }}
      />
      {loading && (
        <p className="font-body text-body-md text-fg-muted">Loading links…</p>
      )}
      {error && (
        <p className="font-body text-body-md text-error" role="alert">
          {error}
        </p>
      )}
      {usingSamples && (
        <p className="font-body text-body-md text-fg-muted">
          Examples, while the feed fills up.{' '}
          <Link
            to="/drop"
            className="text-primary hover:text-primary-fixed-dim underline underline-offset-2"
          >
            Post a link
          </Link>{' '}
          and yours takes their place.
        </p>
      )}
      {!loading && !error && !usingSamples && preview.length === 0 && (
        <p className="font-body text-body-md text-fg-muted">
          No live links yet.{' '}
          <Link
            to="/drop"
            className="text-primary hover:text-primary-fixed-dim underline underline-offset-2"
          >
            Post the first one
          </Link>
          .
        </p>
      )}
      {!loading && preview.length > 0 && (
        <DropGrid listings={preview} sample={usingSamples} />
      )}
    </section>
  )
}
